var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section main-section" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("title-comp", { attrs: { name: _vm.$t("signup.confirm") } }),
        _c("div", { staticClass: "form-container form-login" }, [
          _c("div", { staticClass: "field" }, [
            _c("p", { staticClass: "has-text-centered" }, [
              _vm._v(
                _vm._s(_vm.$t("signup.confirm_help", { mail: _vm.signupEmail }))
              ),
            ]),
          ]),
          _c("div", { staticClass: "field" }, [
            _c("p", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.confirm_code,
                    expression: "confirm_code",
                  },
                ],
                staticClass: "input",
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("placeholder.confirm_code"),
                  maxlength: "10",
                },
                domProps: { value: _vm.confirm_code },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.confirm_code = $event.target.value
                  },
                },
              }),
            ]),
            _vm.devCode
              ? _c("p", { staticClass: "has-text-centered" }, [
                  _vm._v(_vm._s(_vm.devCode)),
                ])
              : _vm._e(),
          ]),
          !_vm.errorExpired
            ? _c("div", { staticClass: "field margin-top-md" }, [
                _c("p", { staticClass: "control has-text-centered" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      class: _vm.buttonClass,
                      attrs: { type: "button" },
                      on: { click: _vm.submitSignupConfirm },
                    },
                    [_vm._v(_vm._s(_vm.$t("button.continue")))]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.errorCode
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.missing_confirm_code"))),
                  ]),
                ]
              )
            : _vm.errorAuth
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.invalid_login"))),
                  ]),
                ]
              )
            : _vm.errorExpired
            ? _c(
                "article",
                {
                  staticClass: "message is-danger",
                  attrs: { transition: "fade" },
                },
                [
                  _c("div", { staticClass: "message-body" }, [
                    _vm._v(_vm._s(_vm.$t("alert.expired_confirm_code"))),
                    _c("div", { staticClass: "margin-top-md" }, [
                      _c("p", { staticClass: "control has-text-centered" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-primary",
                            class: _vm.buttonClass,
                            attrs: { type: "button" },
                            on: { click: _vm.goBack },
                          },
                          [_vm._v(_vm._s(_vm.$t("button.go_back")))]
                        ),
                      ]),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }